// extracted by mini-css-extract-plugin
export var container = "_r2-0";
export var dotAnimation = "_r2-2";
export var dotsLoading = "_r2-1";